import { render } from "./SubmissionManagement.vue?vue&type=template&id=1dd15821&scoped=true"
import script from "./SubmissionManagement.vue?vue&type=script&lang=js"
export * from "./SubmissionManagement.vue?vue&type=script&lang=js"

import "./SubmissionManagement.vue?vue&type=style&index=0&id=1dd15821&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd15821"]])

export default __exports__